import angular from 'angular';
import referralNoteItem from './referralNoteItem';

export default angular.module('referral.components', [referralNoteItem]).name;
